import { jsxs as s, jsx as d } from "react/jsx-runtime";
import t from "clsx";
import { forwardRef as u } from "react";
import a from "./Button.module.css.js";
import l from "./ButtonAppearance.module.css.js";
import { Pressable as N } from "../Pressable/index.js";
import { LoadingSign as h } from "../../foundations/icons/LoadingSign/index.js";
const L = u(
  ({
    size: o = "md",
    type: p = "button",
    appearance: i = "accent",
    variant: m = "tertiary",
    loading: e = !1,
    active: n = !1,
    children: c,
    leftIcon: f,
    rightIcon: b,
    className: x,
    ...r
  }, y) => /* @__PURE__ */ s(
    N,
    {
      className: t(
        a.container,
        {
          [a[o]]: o,
          [l[i]]: i,
          [l.active]: n,
          [a[m]]: m
        },
        x
      ),
      ref: y,
      type: r.href ? void 0 : p,
      ...r,
      ..."disabled" in r ? { disabled: r.disabled || e } : {},
      "aria-expanded": n,
      children: [
        /* @__PURE__ */ s(
          "span",
          {
            className: t(a.content, {
              [a[o]]: o,
              [a.hidden]: e
            }),
            children: [
              f,
              /* @__PURE__ */ d(
                "span",
                {
                  className: t(a.text, {
                    [a[o]]: o
                  }),
                  children: c
                }
              ),
              b
            ]
          }
        ),
        e && /* @__PURE__ */ d(
          h,
          {
            className: a.loadingIcon,
            "aria-busy": "true",
            "aria-live": "polite",
            ariaLabel: "Loading"
          }
        )
      ]
    }
  )
);
L.displayName = "Button";
export {
  L as Button
};
//# sourceMappingURL=Button.js.map
